<template>
	<div class="main">
		<div class="store-top-bg">
			<img :src="storeDetails.storeLogo" />
			<span></span>
		</div>
		<div class="goods-top-main">
			<h2 class="name fr-s-c">
				<img src="../../assets/img/store_img1.png" />
				<span class="text-line-1">{{storeDetails.shareTitle}}</span>
			</h2>
			<div class="head">
				<img :src="storeDetails.storeLogo" />
				<span>月售{{storeDetails.monthSaleNum}}</span>
			</div>
			<div class="score fr-s-c">
				<van-rate v-model="wholeScore" allow-half :icon="starRed" :void-icon="starGrey" :size="0.34+'rem'" readonly />
				<span>{{wholeScore}}</span>
			</div>
			<div class="label" v-if="storeDetails.labelList.length >= 0">
				<ul class="fr-s-c">
					<li v-for="(item, index) in storeDetails.labelList" :key="index">{{ item.labelContent }}</li>
				</ul>
			</div>
			<div class="describe fr-b-c">
				<span v-if="storeDetails.storeDescribe">{{'“' +storeDetails.storeDescribe+ '”'}}</span>
				<span style="font-weight: 400; color: #909090;">{{storeDetails.businessTime}}</span>
			</div>
			<div class="msg fr-b-c">
				<div class="fr-s-c">
					<span class="sp1 fr-s-c">
						<van-icon name="guide-o" size="0.34rem" />距我{{ (storeDetails.distance/1000).toFixed(2) +'km' }}
					</span>
					<span class="sp2 fr-s-c">
						<van-icon name="eye-o" size="0.34rem" />{{storeDetails.browseNum}}
					</span>
				</div>
				<div>{{storeDetails.followNum}}关注</div>
			</div>
			<div class="notice fr-s-c" v-if="storeDetails.storeNotice">
				<img src="../../assets/img/store_img3.png" />
				<span>{{storeDetails.storeNotice}}</span>
			</div>
			<div class="address fr-b-c">
				<div class="address-left fr-s-c">
					<img src="../../assets/img/store_img2.png" />
					<span>{{storeDetails.storeAddress}}</span>
				</div>
				<div class="address-right fr-c">
					<a :href="'tel:' + storeDetails.storeTelphone"><img src="../../assets/img/store_img4.png" /></a>
				</div>
			</div>
		</div>

		<div class="store-nav fr-b-c">
			<span class="active"  @click="goDownload()">商品</span>
			<span @click="goDownload()">评价</span>
			<span @click="goDownload()">店内环境</span>
			<span @click="goDownload()">店铺监控</span>
		</div>

		<div class="store-goods fr-b-s" style="margin-top: 0.35rem;">
			<div class="store-goods-nav">
				<ul>
					<li v-for="(item, index) in storeDetails.classList" :key="index"
						:class="goodsIndex == index ? 'active fr-c fl-c' : 'fr-c fl-c' " @click="goDownload()">
						<span>{{item.storeGoodsClassName}}</span>
					</li>
				</ul>
			</div>
			<div class="store-goods-main" v-if="storeDetails.classList.length > 0">
				<div class="store-goods-main-top fr-c">
					<div class="fr-c" @click="goDownload()">
						<span>销量</span>
						<img src="../../assets/img/store_img7.png" />
					</div>
					<div class="fr-c" @click="goDownload()">
						<span>价格</span>
						<img src="../../assets/img/store_img6.png" />
					</div>
				</div>
				<div class="store-goods-main-bot">
					
					<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
						<div class="fr-b-s store-goods-li" v-for="(item,index) in goodsList" :key="index" @click="goDownload()">
							<div class="store-goods-li-left fl-c fr-c">
								<img :src="item.goodsImg" />
								<span v-if="item.monthSaleNum <= 0">售罄</span>
							</div>
							<div class="fl-s-s store-goods-li-right">
								<p class="title text-line-1">
									{{item.goodsName}}
								</p>
								<p class="desc text-line-1">
									{{item.goodsDesc}}
								</p>
								<p class="now-price">
									<span>￥</span>{{item.memberPrice}}
								</p>
								<div class="old-price fr-b-c">
									<del>
										{{'￥' +item.goodsPrice}}
									</del>
									<span>
										月售{{item.monthSaleNum}}
									</span>
								</div>
							</div>
						</div>
					</van-list>


				</div>
			</div>
		</div>


		<!-- 底部导航条-->
		<div class="bottom_wrap">
			<div class="bottom">
				<div class="bottom_con">
					<div class="bottom_left">
						<div class="share_img">
							<img src="../../assets/img/logo.png" alt="">
						</div>
						<div class="share_des">
							<p>线上掌柜</p>
							<p>新人注册有红包</p>
						</div>
						<div class="clear"></div>
					</div>
					<div class="bottom_right" @click="goDownload">
						<div>立刻加入</div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		Field,
		Toast,
		Swipe,
		SwipeItem,
		Icon,
		List
	} from 'vant';
	import Vue from 'vue';
	import {
		storedetailsshareModule
	} from "../../request/myFreecharge";
	import {
		publicFun
	} from "@/tools/time.js"
	Vue.use(Field);
	Vue.use(Swipe);
	Vue.use(SwipeItem);
	Vue.use(Icon);
	Vue.use(List);
	export default {
		data() {
			return {
				storeDetails: {
					labelList: [],
					classList: []
				},
				firstClass: '',
				goodsList: [],
				page_index: 1,
				page_size: 10,
				wholeScore: 0,
				starRed: require('../../assets/img/star_red.png'),
				starGrey: require('../../assets/img/star_grey.png'),
				goodsIndex: 0,
				loading: false,
				finished: false,
			}
		},
		filters: {
			formatTime: function(value) {
				console.log(value)
				return publicFun.timestampToTime(Number(value));
			},
		},
		created: async function() {
			await this.getstoredetailshare()
			await this.getstoregoodslistshare(Number(this.firstClass))
		},
		methods: {
			async getstoredetailshare() {
				// this.$route.query.storeID = 2
				// this.$route.query.usertoken = 1628125022700
				// this.$route.query.longitude = 113.687846
				// this.$route.query.latitude = 34.757974
				console.log('000000',this.$route.query.storeID, this.$route.query.usertoken,
						this.$route.query.longitude, this.$route.query.latitude)
				await storedetailsshareModule.storedetailsshare(this.$route.query.storeID, this.$route.query.usertoken,
						this.$route.query.longitude||0, this.$route.query.latitude||0)
					.then((response) => {
						console.log(response)
						switch (response.data.code) {
							case 100: {
								this.storeDetails = response.data.result
								this.wholeScore = Number(response.data.result.wholeScore)
								console.log(response.data.result.wholeScore)
								console.log(this.wholeScore)
								this.firstClass = response.data.result.classList.length > 0 ? response.data.result.classList[1].storeGoodsClassID : ''
								console.log(response.data.result)
							}
							break;
						case 101:
							break;
						case 102:
							Toast.clear();
							break;
						case 100001:
							break;
						}
					}).catch(() => {})
			},
			async getstoregoodslistshare(id) {
				// this.$route.query.usertoken = 1628125022700
				await storedetailsshareModule.storegoodslistshare(this.page_index, this.page_size,
						id, this.$route.query.usertoken)
					.then((response) => {
						console.log(response)
						switch (response.data.code) {
							case 100: {
								this.goodsList = response.data.result
								console.log(response.data.result)
							}
							break;
						case 101:
							break;
						case 102:
							Toast.clear();
							break;
						case 100001:
							break;
						}
					}).catch(() => {})
			},
			onLoad() {
				this.loading = false;

				this.finished = true;
			},
			goDownload() {
				this.$router.push({
					path: '/download',
					query: {
						marktype: 1,
					}
				})

			},

		}
	}
</script>
<style scoped>
	.main {
		width: 100%;
		min-height: 100%;
		background: #F5F7FA;
		padding-bottom: 1.5rem;
	}

	.store-top-bg {
		width: 100%;
		position: relative;
	}

	.store-top-bg img {
		display: block;
		width: 100%;
		height: 6rem;
		object-fit: cover;
	}

	.store-top-bg span {
		display: block;
		width: 100%;
		height: 6rem;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
		background: url(../../assets/img/store_bg.png) no-repeat center;
		background-size: 100%;
	}

	.goods-top-main {
		width: 8.72rem;
		background: #FFFFFF;
		border-radius: 0.4rem;
		margin: 0 auto;
		margin-top: -3rem;
		position: relative;
		z-index: 99;
		padding-bottom: 0.62rem;
	}

	.goods-top-main .name {
		font-size: 0.37rem;
		font-weight: bold;
		color: #323232;
		padding-top: 0.56rem;
		margin-left: 0.53rem;
	}

	.goods-top-main .name img {
		width: 0.48rem;
		height: 0.48rem;
		margin-right: 0.2rem;
	}

	.goods-top-main .name span {
		width: 4.4rem;
	}

	.goods-top-main .head {
		width: 2.13rem;
		height: 1.7rem;
		border-radius: 0.16rem;
		position: absolute;
		right: 0.46rem;
		top: -0.6rem;
	}

	.goods-top-main .head img {
		display: block;
		width: 2.13rem;
		height: 1.7rem;
		border-radius: 0.16rem;
		object-fit: cover;
	}

	.goods-top-main .head span {
		display: block;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 2.13rem;
		height: 0.96rem;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
		border-radius: 0px 0px 0.16rem 0.16rem;
		font-size: 0.32rem;
		font-weight: 500;
		color: #FAFAFA;
		line-height: 1.2rem;
		text-align: center;
	}

	.goods-top-main .score {
		padding-top: 0.3rem;
		margin-left: 0.53rem;
		font-size: 0.42rem;
		font-weight: bold;
		color: #FF6B09;
	}

	.goods-top-main .score span {
		padding-left: 0.2rem;
	}

	.goods-top-main .label {
		padding-top: 0.3rem;
		margin-left: 0.53rem;
		color: #FF0000;
		font-size: 0.26rem;
	}

	.goods-top-main .label li {
		height: 0.45rem;
		background: #FFE4E4;
		border-radius: 0.08rem;
		margin-right: 0.2rem;
		text-align: center;
		font-size: 0.26rem;
		padding: 0 0.1rem;
		line-height: 0.45rem;
	}

	.goods-top-main .describe {
		margin-left: 0.53rem;
		margin-right: 0.53rem;
		font-size: 0.32rem;
		color: #FF9000;
		line-height: 0.5rem;
		margin-top: 0.3rem;
	}

	.goods-top-main .msg {
		margin-left: 0.53rem;
		margin-right: 0.53rem;
		font-size: 0.32rem;
		color: #909090;
		line-height: 0.5rem;
		margin-top: 0.3rem;
	}

	.goods-top-main .msg .sp1 i {
		transform: rotate(-90deg);
		-ms-transform: rotate(-90deg);
		-moz-transform: rotate(-90deg);
		-webkit-transform: rotate(-90deg);
		-o-transform: rotate(-90deg);
	}

	.goods-top-main .msg .sp1 {
		margin-right: 0.3rem;
	}

	.goods-top-main .notice {
		margin-left: 0.53rem;
		margin-right: 0.53rem;
		font-size: 0.37rem;
		color: #323232;
		margin-top: 0.3rem;
	}

	.goods-top-main .notice img {
		width: 0.53rem;
		height: 0.53rem;
		margin-right: 0.3rem;
	}

	.goods-top-main .address {
		margin-left: 0.53rem;
		margin-right: 0.53rem;
		font-size: 0.37rem;
		color: #323232;
		margin-top: 0.5rem;
	}

	.goods-top-main .address .address-left img {
		width: 0.53rem;
		height: 0.53rem;
		margin-right: 0.3rem;
	}

	.goods-top-main .address .address-right img {
		width: 0.45rem;
		height: 0.45rem;
	}

	.goods-top-main .address .address-right {
		border-left: 1px solid #eee;
		padding-left: 0.3rem;
	}

	.store-nav {
		margin-top: 0.66rem;
		margin-left: 0.6rem;
		margin-right: 0.6rem;
	}

	.store-nav span {
		text-align: center;
		font-size: 0.42rem;
		font-weight: bold;
		line-height: 54px;
		color: #323232;
	}

	.store-nav span.active {
		color: #FF0000;
	}

	.store-goods-nav {
		width: 2.4rem;
		background: #fff;
		border-radius: 0.16rem;
	}

	.store-goods-nav li {
		height: 1.6rem;
		font-size: 0.42rem;
		background: #fff;
		border-radius: 0.16rem;
	}

	.store-goods-nav li span {
		display: block;
		height: 0.53rem;
		line-height: 0.53rem;
		text-align: center;
		color: #323232;
		font-weight: 400;
		width: 100%;
	}

	.store-goods-nav li.active {
		background: #F5F7FA;
	}

	.store-goods-nav li.active span {
		color: #FF0000;
		border-left: 3px solid #FF0000;
	}

	.store-goods-main-top {
		width: 6.56rem;
		margin-right: 0.64rem;
		color: #FF0000;
		font-size: 0.37rem;
	}

	.store-goods-main-top>div {
		width: 50%;
	}

	.store-goods-main-top img {
		width: 0.22rem;
		margin-left: 0.2rem;
	}

	.store-goods-main-bot {
		width: 6.56rem;
		margin-right: 0.64rem;
	}

	.store-goods-main-bot {
		margin-top: 0.3rem;
	}
	
	.store-goods-main-bot{
		background-color: #fff;
		border-radius: 0.3rem;
	}

	.store-goods-main-bot .store-goods-li {
		padding: 0.4rem;
		margin-bottom: 0.3rem;
	}
	
	.store-goods-li-left{
		width: 2.13rem;
		height: 2.13rem;
		border-radius: 0.21rem;
		position: relative;
	}

	.store-goods-li .store-goods-li-left img {
		position: absolute;
		left: 0;
		top: 0;
		display: block;
		width: 2.13rem;
		height: 2.13rem;
		border-radius: 0.21rem;
	}
	
	.store-goods-li .store-goods-li-left span{
		position: relative;
		width: 1.33rem;
		height: 1.33rem;
		background: rgba(0,0,0,.5);
		border-radius: 50%;
		line-height: 1.33rem;
		text-align: center;
		color: #FAFAFA;
		font-size: 0.37rem;
	}

	.store-goods-li-right .title {
		font-size: 0.37rem;
		font-weight: bold;
		color: #323232;
		width: 3.25rem;
		margin-top: 0rem;
		margin-bottom: 0.1rem;
	}

	.store-goods-li-right .desc {
		padding: 0 0.15rem;
		height: 0.48rem;
		line-height: 0.48rem;
		background: #FFEDD5;
		border-radius: 6px;
		font-size: 0.26rem;
		font-weight: 500;
		color: #FF940B;
		margin-bottom: 0.15rem;
		max-width: 2.95rem;
	}

	.store-goods-li-right .now-price {
		font-size: 0.37rem;
		color: #FF0000;
		margin-bottom: 0.1rem;
	}
	
	.store-goods-li-right .now-price span{
		font-size: 0.26rem;
	}

	.store-goods-li-right .old-price {
		font-size: 0.26rem;
		color: #909090;
		width: 3.25rem;
	}

	.store-goods-li-right .old-price span {
		font-size: 0.26rem;
		color: #909090;
	}
</style>
